
const EmptyDataMessage = () => {
    return (
        <div >
            <i className="bi bi-info-circle text-center fs-26 text-primary d-block"></i>
            <h4 className="fs-14 text-center">There's no data with the current filters, please try with different ones.</h4>
        </div>
    )
};


export default (EmptyDataMessage);